import { gql } from '@apollo/client';

export default gql`
  mutation UserDisableTwoFactor($code: String!) {
    userDisableTwoFactor(input: { code: $code }) {
      success
    }
  }
`;
